import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ConfigProvider } from 'antd';
import { Provider } from 'react-redux';
import esES from 'antd/es/locale/es_ES';
import { Helmet } from 'react-helmet';
import dayjs from 'dayjs';
import Router from './router/Router';
import store from './redux/store';
import colors from './utils/colors';
import { branches, formatBranchList } from './utils/branches';
import 'dayjs/locale/es-mx';

const queryClient = new QueryClient();

function App() {
  dayjs.locale('es-mx');
  const branchNames = branches.map((branch) => branch.name);
  const branchList = formatBranchList(branchNames);
  const branchKeywords = branchNames.join(', ');

  return (
    <Provider store={store}>
      <ConfigProvider
        theme={{ token: { colorPrimary: colors.primary[0], borderRadius: 16 } }}
        locale={esES}
      >
        <QueryClientProvider client={queryClient}>
          <Helmet>
            <title>Taquito Grill. El sabor de los deportes.</title>
            <meta name="keywords" content={`Taquito Grill, Restaurante ${branchKeywords}, Tacos, Tacos ${branchKeywords}, Restaurante Deportivo`} />
            <meta name="description" content={`Disfruta de tus deportes favoritos y deliciosos tacos en nuestro restaurante deportivo, visítanos en ${branchList}. ¡Ven y prueba nuestros cortes, parrilladas y más!`} />
            <meta httpEquiv="content-language" content="es" />
          </Helmet>
          <Router />
        </QueryClientProvider>
      </ConfigProvider>
    </Provider>
  );
}

export default App;
